import { useState } from 'react';
import './i18n';
import {useTranslation} from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import Advance from "./Advance";
import RadioButtonGroup from "./RadioButtonGroup";
import ByIdentifier from "./ByIdentifier";

function App() {
    const {t} = useTranslation();

    const [paymentType, setPaymentType] = useState('advance');

    const handlePaymentTypeChange = (value) => setPaymentType(value);

    const options = [
        {value: 'advance', label: t('Advance')},
        {value: 'by identifier', label: t('By identifier')},
    ];

    let componentToRender = null;

    if (paymentType === 'advance') {
        componentToRender = <Advance/>
    } else if (paymentType === 'by identifier') {
        componentToRender = <ByIdentifier/>
    }

    return (
        <>
            <div className='header-wrapper'>
                <div className='header'>
                    <img className='logo' src='logo.svg' alt='logo' />
                    <div className='header-brand'>
                        <p className='brand-text'>{t('SCS KR')}</p>
                        <p className='brand-text'>{t('Customs\' payments')}</p>
                    </div>
                </div>
                <LanguageSwitcher/>
            </div>

            <div className="app-container">
                <div className="col-12 col-md-7 col-lg-5 px-3">
                    <div className="form-group">
                        <div className="form-label">{t('Payment Type')}</div>
                        <RadioButtonGroup
                            options={options}
                            value={paymentType}
                            onChange={handlePaymentTypeChange}
                        />
                    </div>

                    {componentToRender}
                </div>
            </div>
        </>
    );
}

export default App;
